module.exports = __webpack_public_path__ + "img/toux.7b4cee7.png";